import { defineMessages } from 'react-intl'

/**
 * Non-Société framing of the LuxPlus+ renewal bonus. Shared by the re-enable renewal
 * success screen and the cancel-renewal retention step.
 */
const nonSocieteRenewalBonusMessages = defineMessages({
  joinBonusFull: {
    id: 'M7ObkPf5bfZT9AOTanMG',
    defaultMessage: 'Join <link>Société</link> for free before your membership renews on <b>{date}</b> to receive a renewal bonus of {loyaltyPoints} and {statusCredits}.',
    description: 'Renewal bonus sentence with a join-Société link, shown to a LuxPlus+ member who has not joined Société',
  },
  joinBonusPoints: {
    id: 'B-eT_55BKbIQ01sGdxr_',
    defaultMessage: 'Join <link>Société</link> for free before your membership renews on <b>{date}</b> to receive a renewal bonus of {loyaltyPoints}.',
    description: 'Points-only renewal bonus sentence with a join-Société link, shown to a LuxPlus+ member who has not joined Société',
  },
})

export default nonSocieteRenewalBonusMessages
